/**
 * Import image assets to be included with theme
 */

// import './image.png';

/**
 * Default export -- This may be left empty. Import all images above.
 *
 * @export
 */
export default function() {}


// WEBPACK FOOTER //
// ./assets/src/images/index.js